import {useState} from 'react';
import {Button, Input, Row, Col, InputNumber} from 'antd';
import {insertPurchaseOrderLabor} from "../../api/Api";
import {PURCHASE_ORDER_LABOR_MAX_LENGTH} from "../../api/Constants";
import {handleNoSession} from "../../util/errorUtils";


const {TextArea} = Input;

export const NewPOLaborWidget = ({purchaseOrder, io, props}) => {
    const [notes, setNotes] = useState(undefined);
    const [hours, setHours] = useState(undefined);
    const {onApiFail, onRefresh} = io;

    const clearForm = () => {
        setNotes(undefined);
        setHours(undefined);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onHoursChange = (val) => {
        setHours(val);
    }

    const onClick = () => {
        insertPurchaseOrderLabor(purchaseOrder.id, notes, hours).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            handleNoSession(e, onApiFail);
        }).finally(() => {
            clearForm();
        })

        clearForm();
    }

    const rowStyle= {
        marginTop: '5px', marginBottom: '10px'
    }

    const okDisabled = (notes === undefined) || (hours === undefined) || (notes.trim().length === 0);

    return <div>
        <Row style={rowStyle}><b>New Labor Item</b>

        </Row>
        <Row style={rowStyle}>
            <TextArea value={notes} placeholder={`New Labor Item`} rows={2} maxLength={PURCHASE_ORDER_LABOR_MAX_LENGTH} showCount onChange={onNotesChange}/>
        </Row>
        <Row style={rowStyle}>
            <Col span={2}>
                <InputNumber onChange={onHoursChange} placeholder={'Hours'} min={0} precision={2} value={hours}/>
            </Col>
            {(hours === undefined) &&
                <Col style={{color:'red'}}>
                    Enter the number of hours spent on this task.
                </Col>
            }
        </Row>
        <Row style={rowStyle}>
            <Button onClick={onClick} disabled={okDisabled}>Ok</Button>
        </Row>
    </div>
}